import useTranslation from 'next-translate/useTranslation';
import { useContext, useEffect, useState } from 'react';
import Cart from '@/components/cart';
import CrossIcon from '@/components/icons/Cross';
import { ASSISTED_USER_ID, ASSISTED_USER_NAME, ASSISTED_USER_NUMBER, NAVIGATION_FROM_IS_ASSISTED_ORDERING } from '@/constants/common';
import { CartContext } from '@/context/CartProvider';
import { isShareChatUtmSession } from '@/utils/analytics/utmParams';
import { getNumberOfItemsInCart } from '@/utils/cart';
import { getCookieValue } from '@/utils/helper';
import CartIcon from '../icons/CartIcon';
import SelectFarmer from '../selectedFarmer/SelectFarmer';
const MyCart = () => {
  const {
    t
  } = useTranslation('cart');
  const {
    cartItems,
    comboItems
  } = useContext(CartContext);
  const noOfItemsInCart = getNumberOfItemsInCart({
    ...cartItems,
    ...comboItems
  });
  const [isOpen, setIsOpen] = useState(false);
  const orderingFor = getCookieValue(NAVIGATION_FROM_IS_ASSISTED_ORDERING) === 'true';
  const [isFarmerSelected, setIsFarmerSelected] = useState(false);
  const [showAddFarmer, setShowAddFarmer] = useState(false);
  const isAssumeUser = [getCookieValue(ASSISTED_USER_ID), getCookieValue(ASSISTED_USER_NAME), getCookieValue(ASSISTED_USER_NUMBER)].every(Boolean);
  useEffect(() => {
    if (isOpen) document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [isOpen]);
  const onClose = () => {
    setIsOpen(false);
    setShowAddFarmer(false);
    setIsFarmerSelected(false);
  };
  useEffect(() => {
    const closeDrawer = () => {
      setIsOpen(false);
    };
    // Listen for CLOSE_CART_DRAWER event
    window.addEventListener('CLOSE_CART_DRAWER', closeDrawer);

    // Clean up event listener
    return () => {
      window.removeEventListener('CLOSE_CART_DRAWER', closeDrawer);
    };
  }, []);
  useEffect(() => {
    if (isOpen && typeof window !== 'undefined' && window.scq && isShareChatUtmSession()) {
      window.scq('Initiate checkout', 'pre_defined');
    }
  }, [isOpen]);
  return <>
      <button data-testid="my-cart" className="flex flex-shrink-0 items-center bg-primary-100 shadow-sm mr-2 ml-3 p-2 rounded-lg text-white" onClick={() => setIsOpen(true)}>
        <CartIcon className="mr-1" data-sentry-element="CartIcon" data-sentry-source-file="MyCart.tsx" />
        <span className="mr-auto">{t('my_cart')}</span>
        {noOfItemsInCart ? <div data-testid="my-cart-count" className="flex justify-center items-center bg-secondary-two-110 ml-2 border-2 rounded-full w-8 h-6 text-sm">
            {noOfItemsInCart || 0}
          </div> : ''}
      </button>

      <section data-testid={`side-drawer-section-${isOpen ? 'open' : 'close'}`} className="z-60 fixed inset-0 bg-gray-900 bg-opacity-25 p-0 overflow-hidden transition-all duration-300 ease-in-out" style={{
      opacity: isOpen ? 1 : 0,
      visibility: isOpen ? 'visible' : 'hidden'
    }} onClick={onClose}></section>
      <section className="top-0 right-0 z-60 fixed bg-white shadow-xl min-w-[456px] max-w-sm h-full text-neutral-90 transition-all duration-300 ease-in-out delay-100" style={{
      transform: `translateX(${isOpen ? '0px' : '100%'})`
    }}>
        <article className="relative flex flex-col max-w-lg h-full overflow-y-scroll text-lg">
          <header className="z-10 fixed flex justify-between bg-white shadow-[0_6px_20px_rgba(0,0,0,0.05)] p-[18px] w-full font-bold text-lg align-center">
            <h5 className="flex-grow text-neutral-90">{t('cart:my_cart')}</h5>
            <CrossIcon onClick={onClose} className="fill-transparent stroke-neutral-80 mx-4 w-6 h-6 cursor-pointer" data-testid="product-filters-close-icon" data-sentry-element="CrossIcon" data-sentry-source-file="MyCart.tsx" />
          </header>
          {orderingFor && !isFarmerSelected && !isAssumeUser ? <SelectFarmer isDrawerOpen={isOpen} isAddFarmerFormVisible={showAddFarmer} setShowAddFarmer={setShowAddFarmer} onFarmerSelected={() => setIsFarmerSelected(true)} /> : <Cart isDrawer isDrawerOpen={isOpen} />}
        </article>
      </section>
    </>;
};
export default MyCart;